export enum ToastType {
  success,
  info,
  warning,
  danger
}
